import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

class Input extends React.Component {
    render() {
        const {
            inputLabel,
            inputOnClick,
            inputDisabled,
            inputColor,
            inputClassName,
            inputLoading
        } = this.props;

        return (
            <span className="btn-container">
        <Button
            type="button"
            fullWidth
            variant="contained"
            onClick={inputOnClick}
            color={inputColor}
            className={inputClassName}
            disabled={inputDisabled}
        >
          {inputLabel}
        </Button>
                {inputLoading && <CircularProgress size={24} className="progress"/>}
      </span>
        );
    }
}

Input.propTypes = {
    inputOnClick: PropTypes.func,
    inputColor: PropTypes.string,
    inputClassName: PropTypes.string,
    inputDisabled: PropTypes.bool
};

export default Input;



// WEBPACK FOOTER //
// ./src/Controls/Button.js